import React from 'react';
import { getBoletoStatusPresentation } from '~/services/boletoPaymentStatus';
import Style from './PaymentStatus.style';

export function PaymentStatus({ transaction, status }: any): any {
   if (
      transaction &&
      transaction.payment_type == 'boleto' &&
      (!!transaction.payment_method?.status || transaction.cancel)
   ) {
      const boletoStatus =
         transaction.payment_method?.status ?? transaction.payment_status ?? undefined;
      const { label, badgeClass } = getBoletoStatusPresentation(
         boletoStatus,
         transaction.expiration_date ?? transaction.payment_method?.expiration_date,
         transaction.cancel,
      );

      return (
         <Style>
            <div className={`badge ${badgeClass}`}>{label}</div>
         </Style>
      );
   }

   let text = '';
   const currentStatus = transaction?.status || status;

   switch (currentStatus) {
      case 'paid':
         text = 'Pago';
         break;
      case 'succeeded':
         text = 'Aprovada';
         break;
      case 'canceled':
         text = 'Cancelada';
         break;
      case 'blocked':
         text = 'Bloqueada';
         break;
      case 'charged_back':
         text = 'Charge back';
         break;
      case 'dispute':
         text = 'Disputa';
         break;
      case 'failed':
         text = 'Falhada';
         break;
      case 'pending':
         text = 'Pendente';
         break;
      case 'reversed':
         text = 'Pré-autorizado';
         break;
      case 'refunded':
         text = 'Revertida';
         break;
   }

   return (
      <Style>
         <div className={`badge badge-${currentStatus}`}>{text}</div>
      </Style>
   );
}
